<ng-conatiner *ngIf="cs.isBrowser && isLockType">
  <div
    class="icon lock-image-contain"
    *ngIf="isLocked; else unlockStatus"
    (click)="showUnlockingOptions()"
  >
    <em class="icon-litelock-filled-white-new1"></em>
  </div>
</ng-conatiner>

<ng-template #unlockStatus>
  <div class="icon lock-image-contain">
    <em class="icon-liteunlock-filled-white"></em>
  </div>
</ng-template>

<app-alert-modal
  #unlockOptions
  [headerLabel]="headerLabel"
  (canceled)="handleOptionsCancel()"
  [showConfirmationBtn]="false"
  [modalOptions]="{ class: isLivestreamContext ? 'unlock-content-modal livestream-desktop-right-modal' : 'unlock-content-modal' }"
>
  <div class="order-options">
    <div class="d-flex flex-column gap-3">
      <div>
        {{ unlockDescription }}:
      </div>
      <app-button
        *ngIf="lockDetails?.is_subscription"
        [btnField]="{
          label: labels.SUBSCRIBE,
          class: 'btn btn-primary w-100'
        }"
        (handleButtonClick)="
          lockContentSelected(lockDetails, lockFields.SUBSCRIPTION)
        "
      ></app-button>
      <app-button
        *ngIf="lockDetails?.is_individual_price"
        [btnField]="{
          label: labels.PAY + (lockDetails?.individual_price | currency),
          class: 'btn btn-primary w-100'
        }"
        (handleButtonClick)="
          lockContentSelected(lockDetails, lockFields.INDIVIDUAL_PURCHASE)
        "
      ></app-button>
      <app-button
        *ngIf="lockDetails?.is_nft"
        [btnField]="{
          label: labels.NFT,
          class: 'btn btn-primary w-100'
        }"
        (handleButtonClick)="
          lockContentSelected(lockDetails, lockFields.LOCK_NFT)
        "
      ></app-button>
    </div>
  </div>
</app-alert-modal>

<app-nft-unlock-modal
  #nftUnlock
  [modalHeader]="label"
  [headerType]="headerType"
  [contentType]="contentType"
  (confirmed)="confirmNftOffer()"
  (canceled)="handleCancel()"
  [modalOptions]="{ class: isLivestreamContext ? 'unlock-content-modal livestream-desktop-right-modal' : 'unlock-content-modal' }"
></app-nft-unlock-modal>
